var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarFilledBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2.5h-1.876v-.625a.625.625 0 10-1.25 0V2.5h-6.25v-.625a.625.625 0 00-1.25 0V2.5H3.75A1.251 1.251 0 002.5 3.75v12.5a1.251 1.251 0 001.25 1.25h12.5a1.25 1.25 0 001.25-1.25V3.75a1.25 1.25 0 00-1.25-1.25zm0 3.75H3.75v-2.5h1.875v.625a.625.625 0 001.25 0V3.75h6.25v.625a.625.625 0 001.25 0V3.75h1.875v2.5z",
    fill: "#33647E"
  })));
}
export default SvgCalendarFilledBlue;